import { removeTokens, RequestClient } from "@shapr3d/frontend-lib";

import {
  appVersionHeaderName,
  Environment,
  environment,
  syncApiUrl,
  trackingIDHeaderName,
  UMSApiUrl,
} from "../config";
import { trackingAdapter } from "../lib/TrackingAdapter";
import { SearchParam } from "../types";
import { version } from "../version";

const defaultHeaders = {
  "Content-Type": "application/json",
  [appVersionHeaderName]: environment === Environment.PROD ? version : "0.0.0", // Sync API requires a valid semver version header
  get [trackingIDHeaderName]() {
    return trackingAdapter.getTrackingID();
  },
};

export const TOKEN_AUDIENCE = "web";

export const SyncRequestClient = new RequestClient({
  baseUrl: syncApiUrl,
  authBaseUrl: UMSApiUrl,
  defaultHeaders,
  audience: TOKEN_AUDIENCE,
  logoutCallback: () => {
    trackingAdapter.reset();
    removeTokens();

    const url = new URL(window.location.href);
    url.searchParams.delete(SearchParam.EmailToken);
    window.location.replace(url.toString());
  },
});

export const UMSrequestClient = new RequestClient({
  baseUrl: UMSApiUrl,
  defaultHeaders,
  audience: TOKEN_AUDIENCE,
  logoutCallback: () => {
    trackingAdapter.reset();
    removeTokens();

    const url = new URL(window.location.href);
    url.searchParams.delete(SearchParam.EmailToken);
    window.location.replace(url.toString());
  },
});
